import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-wrap" }
const _hoisted_2 = { class: "bg-layout" }
const _hoisted_3 = { class: "bg-list" }
const _hoisted_4 = { class: "bg-list-head" }
const _hoisted_5 = {
  key: 0,
  class: "bg-muted"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "bg-li-slug" }
const _hoisted_8 = {
  key: 1,
  class: "bg-muted"
}
const _hoisted_9 = {
  key: 0,
  class: "bg-editor"
}
const _hoisted_10 = { class: "bg-row" }
const _hoisted_11 = { class: "bg-field" }
const _hoisted_12 = { class: "bg-field bg-color" }
const _hoisted_13 = { class: "bg-field bg-active" }
const _hoisted_14 = { class: "bg-row" }
const _hoisted_15 = { class: "bg-field" }
const _hoisted_16 = { class: "bg-field" }
const _hoisted_17 = { class: "bg-field" }
const _hoisted_18 = { class: "bg-field" }
const _hoisted_19 = { class: "bg-feat-head" }
const _hoisted_20 = {
  key: 0,
  class: "bg-muted"
}
const _hoisted_21 = { class: "bg-preview" }
const _hoisted_22 = { class: "bgp-content" }
const _hoisted_23 = { class: "bgp-logo" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "bgp-logo-text"
}
const _hoisted_26 = { class: "bgp-title" }
const _hoisted_27 = { class: "bgp-subtitle" }
const _hoisted_28 = { class: "bgp-features" }
const _hoisted_29 = { class: "bgp-feat-txt" }
const _hoisted_30 = { class: "bgp-feat-title" }
const _hoisted_31 = { class: "bgp-feat-desc" }
const _hoisted_32 = { class: "bg-actions" }
const _hoisted_33 = {
  key: 1,
  class: "bg-editor bg-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[30] || (_cache[30] = _createElementVNode("p", { class: "bg-intro" }, [
      _createTextVNode(" Personalizează pagina de login pentru fiecare client, după subdomeniu (ex. "),
      _createElementVNode("strong", null, "demo"),
      _createTextVNode(" → demo.era-erp.ro, "),
      _createElementVNode("strong", null, "portalhr"),
      _createTextVNode(" → portalhr.era-erp.ro). Modificările apar imediat la următoarea încărcare a paginii de login. ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createElementVNode("span", null, "Clienți", -1)),
          _createVNode(_component_v_btn, {
            size: "small",
            color: "#ff2c21",
            variant: "flat",
            onClick: _ctx.addNew
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                start: "",
                size: "16"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("mdi-plus", -1)
                ]))]),
                _: 1
              }),
              _cache[8] || (_cache[8] = _createTextVNode(" Adaugă ", -1))
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Se încarcă..."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (b) => {
          return (_openBlock(), _createElementBlock("button", {
            key: b.slug,
            class: _normalizeClass(["bg-list-item", { active: _ctx.selected && _ctx.selected.slug === b.slug }]),
            onClick: ($event: any) => (_ctx.select(b))
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(b.slug), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["bg-li-badge", { off: !b.active }])
            }, _toDisplayString(b.active ? 'activ' : 'inactiv'), 3)
          ], 10, _hoisted_6))
        }), 128)),
        (!_ctx.loading && !_ctx.items.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Niciun client configurat."))
          : _createCommentVNode("", true)
      ]),
      (_ctx.selected)
        ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[10] || (_cache[10] = _createElementVNode("label", null, "Slug (subdomeniu) *", -1)),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.selected.slug,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected.slug) = $event)),
                  disabled: !_ctx.isNew,
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  placeholder: "ex: demo"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[11] || (_cache[11] = _createElementVNode("label", null, "Culoare accent", -1)),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.selected.color,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected.color) = $event)),
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  placeholder: "red darken-1 sau #ff2c21"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[12] || (_cache[12] = _createElementVNode("label", null, "Activ", -1)),
                _createVNode(_component_v_switch, {
                  modelValue: _ctx.selected.active,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selected.active) = $event)),
                  color: "#ff2c21",
                  "hide-details": "",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[13] || (_cache[13] = _createElementVNode("label", null, "Logo (text)", -1)),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.selected.logoText,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selected.logoText) = $event)),
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  placeholder: "ERA"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[14] || (_cache[14] = _createElementVNode("label", null, "Logo (URL imagine, opțional)", -1)),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.selected.logoUrl,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selected.logoUrl) = $event)),
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  placeholder: "https://..."
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[15] || (_cache[15] = _createElementVNode("label", null, "Titlu", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.selected.title,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selected.title) = $event)),
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                placeholder: "Bine ați venit"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[16] || (_cache[16] = _createElementVNode("label", null, "Subtitlu", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.selected.subtitle,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selected.subtitle) = $event)),
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                placeholder: "Sistem ERP..."
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[19] || (_cache[19] = _createElementVNode("span", null, "Module / features afișate", -1)),
              _createVNode(_component_v_btn, {
                size: "x-small",
                variant: "tonal",
                onClick: _ctx.addFeature
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    start: "",
                    size: "14"
                  }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("mdi-plus", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[18] || (_cache[18] = _createTextVNode(" Adaugă rând ", -1))
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected.features, (f, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "bg-feat-row"
              }, [
                _createVNode(_component_v_text_field, {
                  modelValue: f.icon,
                  "onUpdate:modelValue": ($event: any) => ((f.icon) = $event),
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  placeholder: "mdi-shield-check",
                  style: {"max-width":"190px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: f.color,
                  "onUpdate:modelValue": ($event: any) => ((f.color) = $event),
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  placeholder: "#4CAF50",
                  style: {"max-width":"110px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: f.title,
                  "onUpdate:modelValue": ($event: any) => ((f.title) = $event),
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  placeholder: "Titlu"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: f.desc,
                  "onUpdate:modelValue": ($event: any) => ((f.desc) = $event),
                  density: "compact",
                  variant: "outlined",
                  "hide-details": "",
                  placeholder: "Descriere"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  size: "x-small",
                  variant: "text",
                  color: "#ef4444",
                  onClick: ($event: any) => (_ctx.selected.features.splice(i, 1))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode("mdi-delete-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            }), 128)),
            (!_ctx.selected.features.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Niciun feature. Se afișează doar titlul."))
              : _createCommentVNode("", true),
            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "bg-prev-head" }, "Previzualizare pagină login", -1)),
            _createElementVNode("div", _hoisted_21, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "bgp-orbs" }, [
                _createElementVNode("span"),
                _createElementVNode("span"),
                _createElementVNode("span")
              ], -1)),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_ctx.selected.logoUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.selected.logoUrl,
                        alt: "logo",
                        class: "bgp-logo-img"
                      }, null, 8, _hoisted_24))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.selected.logoText || 'ERA'), 1)),
                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "bgp-logo-sub" }, "Enterprise Resource Application", -1))
                ]),
                _createElementVNode("h2", _hoisted_26, _toDisplayString(_ctx.selected.title || 'Bine ați venit'), 1),
                _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.selected.subtitle || 'Sistem ERP'), 1),
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected.features, (f, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "bgp-feat"
                    }, [
                      _createElementVNode("span", {
                        class: "bgp-feat-ico",
                        style: _normalizeStyle({ background: _ctx.hexAlpha(f.color) })
                      }, [
                        _createVNode(_component_v_icon, {
                          color: f.color || '#fff',
                          size: "20"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(f.icon || 'mdi-star'), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ], 4),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(f.title || 'Titlu'), 1),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(f.desc), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_v_btn, {
                color: "#ff2c21",
                loading: _ctx.saving,
                onClick: _ctx.save
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { start: "" }, {
                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                      _createTextVNode("mdi-content-save", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[24] || (_cache[24] = _createTextVNode(" Salvează ", -1))
                ]),
                _: 1
              }, 8, ["loading", "onClick"]),
              (!_ctx.isNew)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    variant: "tonal",
                    color: "#ef4444",
                    loading: _ctx.deleting,
                    onClick: _ctx.remove
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createTextVNode("mdi-delete", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[26] || (_cache[26] = _createTextVNode(" Șterge ", -1))
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_33, [
            _createVNode(_component_v_icon, {
              size: "48",
              color: "#cbd5e1"
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode("mdi-palette-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[29] || (_cache[29] = _createElementVNode("p", null, "Selectează un client sau adaugă unul nou.", -1))
          ]))
    ])
  ]))
}